export default {
  methods: {
    runSignupTrackingScripts () {
      this.runFacebookPixelScript()
      this.runCrwdcntrlScript()
    },
    runFacebookPixelScript () {
      var facebookPixelScript = function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }; if (!f._fbq) f._fbq = n
        n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0
        t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
      }
      facebookPixelScript(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      window.fbq('init', '699874493477017')
      window.fbq('track', 'PageView')
    },
    runCrwdcntrlScript () {
      var crwdcntrlScript = document.createElement('script')
      crwdcntrlScript.type = 'text/javascript'
      crwdcntrlScript.src = 'https://tags.crwdcntrl.net/c/12270/cc.js?ns=_cc12270'
      crwdcntrlScript.id = 'LOTCC_12270'
      document.body.appendChild(crwdcntrlScript)

      crwdcntrlScript.onload = function () {
        window._cc12270.bcp()
      }
    },
    googleAdwordsConversionScript () {
      window.gtag('event', 'conversion', {'send_to': 'AW-971987303/w2EUCM7xuHQQ57K9zwM'})
    }
  }
}
